import React from 'react';
import {
  Box,
  Backdrop,
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
} from '../../imports/muiImport';

import { CircularProgress } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import BasicBtn from '../../components/button/BasicBtn';
import { validateEmail } from '../../shared/validation';
import { actionNotifier } from '../../components/tostify';
import { loginUser } from '../../apiCalls/urls/urlFunction';

const Login = ({ setOTPForm, setIsUserAuthentic }) => {
  const [loginFormValues, setLoginFormValues] = React.useState({
    email: '',
    password: '',
    emailError: '',
    passwordError: '',
    isShowPassword: false,
    isLoginFormLoading: false,
  });

  const handlerValueInput = (e) => {
    const { name, value } = e.target;

    setLoginFormValues((pv) => {
      const next = { ...pv, [name]: value };

      if (name === 'email') {
        next.emailError = validateEmail(value) ? '' : 'Enter a valid email address';
      }

      if (name === 'password') {
        next.passwordError = value?.length < 6 ? 'Password must be at least 6 characters' : '';
      }

      return next;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoginFormValues(() => ({ ...loginFormValues, isLoginFormLoading: true }));
    if (loginFormValues.emailError || loginFormValues.passwordError) {
      const errMsg =
        loginFormValues.emailError ||
        loginFormValues.passwordError ||
        'Please fix the errors before submitting.';
      actionNotifier.error(errMsg, { position: 'top-left', autoClose: 3000 });
      setLoginFormValues(() => ({ ...loginFormValues, isLoginFormLoading: false }));
      return;
    }

    const handlerloginUser = async () => {
      const payload = {
        email: loginFormValues.email,
        password: loginFormValues.password,
      };
      const loginRes = await loginUser(payload);
      // console.log('login Response :', loginRes);

      if (!loginRes.status) {
        actionNotifier.error(loginRes?.message || 'Login failed. Please try again.', {
          position: 'top-left',
          autoClose: 3000,
        });
        setLoginFormValues(() => ({ ...loginFormValues, isLoginFormLoading: false }));
        return;
      }
      setOTPForm(() => true);
      setIsUserAuthentic(() => ({
        email: loginFormValues.email,
        password: loginFormValues.password,
      }));
      actionNotifier.success(loginRes?.message, {
        position: 'top-left',
        autoClose: 3000,
      });
      setLoginFormValues(() => ({ ...loginFormValues, isLoginFormLoading: false }));
    };

    handlerloginUser();
  };

  return (
    <Box component="div">
      <FormControl component="form" method="post" onSubmit={handleSubmit} fullWidth>
        <TextField
          fullWidth
          label="Email Address"
          variant="outlined"
          name="email"
          value={loginFormValues.email}
          type="email"
          onChange={handlerValueInput}
          error={!!loginFormValues.emailError}
          helperText={loginFormValues.emailError}
          required
          margin="normal"
          sx={{ backgroundColor: 'white.main', border: 0 }}
        />

        <TextField
          fullWidth
          label="Password"
          variant="outlined"
          name="password"
          type={loginFormValues.isShowPassword ? 'text' : 'password'}
          value={loginFormValues.password}
          onChange={handlerValueInput}
          error={!!loginFormValues.passwordError}
          helperText={loginFormValues.passwordError}
          required
          margin="normal"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() =>
                    setLoginFormValues((pv) => ({
                      ...pv,
                      isShowPassword: !pv.isShowPassword,
                    }))
                  }
                  edge="end"
                >
                  {loginFormValues.isShowPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ backgroundColor: 'white.main', border: 0 }}
        />

        <BasicBtn type="submit" name="Sign in" color="secondary" smColor="primary" sx={{ mt: 3 }} />
      </FormControl>

      <Backdrop sx={{ color: '#fff', zIndex: 999 }} open={loginFormValues.isLoginFormLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default Login;
